import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/common/ScrollToTop';
import MainLayout from './components/layout/MainLayout';
import Home from './pages/Home';
import About from './pages/About';
import Articles from './pages/Articles';
import ChiefEditor from './pages/ChiefEditor';
import Contact from './pages/Contact';
import ArticleOncologySurrogateEndpoints from './pages/ArticleOncologySurrogateEndpoints';
import ArticleAntibioticStewardshipOutpatient from './pages/ArticleAntibioticStewardshipOutpatient';
import ArticleBiosimilarsPatientGuide from './pages/ArticleBiosimilarsPatientGuide';
import ArticleCardiovascularRiskCalculators from './pages/ArticleCardiovascularRiskCalculators';
import ArticleSleepApneaScreening from './pages/ArticleSleepApneaScreening';
import ArticleGlp1MuscleMass from './pages/ArticleGlp1MuscleMass';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="articles" element={<Articles />} />
          <Route path="chief-editor" element={<ChiefEditor />} />
          <Route path="articles/oncology-surrogate-endpoints" element={<ArticleOncologySurrogateEndpoints />} />
          <Route path="articles/antibiotic-stewardship-outpatient" element={<ArticleAntibioticStewardshipOutpatient />} />
          <Route path="articles/biosimilars-patient-guide" element={<ArticleBiosimilarsPatientGuide />} />
          <Route path="articles/cardiovascular-risk-calculators" element={<ArticleCardiovascularRiskCalculators />} />
          <Route path="articles/sleep-apnea-screening" element={<ArticleSleepApneaScreening />} />
          <Route path="articles/glp1-muscle-mass" element={<ArticleGlp1MuscleMass />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
